import { TableComponentState } from '../../shared/types/TableComponentState';
import { MasterStandingAuthTableColumn } from '../../shared/types/MasterStandingAuthTableColumn';
import { createReducer, on } from '@ngrx/store';
import { StandingAuthMasterStatusTableActions, StandingAuthMasterStatusViewActions } from '../actions';

export const saMasterStatusTableStatekey = 'saMasterStatusTableState';

export interface State extends TableComponentState {
  currentStandingAuth?: MasterStandingAuthTableColumn;
  currentTab: string;
}

export const initialMasterStandingAuthTableState: State = {
  currentTab: 'ALL',
  currentStandingAuth: {
    'Account number': '',
    'Account name': '',
    'Registration type': '',
    Type: '',
    'To/From': '',
    Direction: ''
  },
  isInitialLoad: false,
  gridReady: false,
  printClicked: false,
  loading: false,
  error: '',
  hasError: false
}

export const masterStandingAuthTableStateReducer = createReducer(
  initialMasterStandingAuthTableState,
  on(StandingAuthMasterStatusTableActions.gridReady, (state, action) => {
    return {
      ...state,
      gridReady: action.gridReady,
      currentTab: action.tab
    }
  }),
  on(StandingAuthMasterStatusViewActions.callLetters,
    StandingAuthMasterStatusViewActions.refreshSaMaster,
    StandingAuthMasterStatusViewActions.getBookmarkedAccounts,
    (state) => {
      return {
        ...state,
        loading: true,
        error: '',
        hasError: false,
        cancelLinkClicked: true,
        letters: []

      }
  }),
  on(StandingAuthMasterStatusViewActions.callLettersSuccess, (state) => {
      return {
        ...state,
        loading: false,
        error: '',
        hasError: false,
        cancelLinkClicked: false
      }
    }),
    on(StandingAuthMasterStatusViewActions.callLettersFailure, (state, err) =>{
      return {
        ...state,
        loading: false,
        error: err.message,
        hasError: true,
        cancelLinkClicked: false
      }
    }),
    on(StandingAuthMasterStatusViewActions.callLettersEmptyResponse, (state) => {
      return {
        ...state,
        hasEmptyResponse: true,
        loading: false,
        error: '',
        hasError: false,
        cancelLinkClicked: false
      }
    }),
     on(StandingAuthMasterStatusViewActions.callBookmarkedAccountsSuccess, (state) => {
      return {
        ...state,
        loading: false,
        error: '',
        hasError: false,
        cancelLinkClicked: false
      }
    }),
    on(StandingAuthMasterStatusTableActions.printClicked, (state) => {
      return {
        ...state,
        printClicked: true
      }
    })
)
